import useMutation from '../../../../ReactQuery/useMutation';
import { post } from '../../../../redux/api';
import type { VerifyMfaRequest, VerifyMfaResponse } from '../../../../../shared/types/routes/auth/mfa';

function verifyMfa(request: VerifyMfaRequest) {
  return post<VerifyMfaRequest, VerifyMfaResponse>('/api/auth/mfa/login/verify', request);
}

/**
 * Verify MFA code during login (partial authentication state)
 */
export function useVerifyLoginMfa() {
  return useMutation({
    mutationFn: verifyMfa,
  });
}
